export const PLACAS_LISTAR = "PLACAS_LISTAR";
export const PLACAS_LISTAR_SUCCESS = "PLACAS_LISTAR_SUCCESS";
export const PLACAS_LISTAR_ERROR = "PLACAS_LISTAR_ERROR";

export const listarPlacas = (paginacion) => ({
  type: PLACAS_LISTAR,
  paginacion,
});

export const listarPlacasSuccess = (respuestaServidor) => ({
  type: PLACAS_LISTAR_SUCCESS,
  respuestaServidor,
});

export const listarPlacasError = (error) => ({
  type: PLACAS_LISTAR_ERROR,
  error,
});

export const GUARDAR_PLACA = "GUARDAR_PLACA";
export const GUARDAR_PLACA_SUCCESS = "GUARDAR_PLACA_SUCCESS";
export const GUARDAR_PLACA_ERROR = "GUARDAR_PLACA_ERROR";

export const guardarPlaca = (placa, onSuccess) => {
  return {
    type: GUARDAR_PLACA,
    placa,
    onSuccess,
  };
};
export const guardarPlacaSuccess = (respuestaServidor) => ({
  type: GUARDAR_PLACA_SUCCESS,
  respuestaServidor,
});

export const guardarPlacaError = (errorContenido) => ({
  type: GUARDAR_PLACA_ERROR,
  errorContenido,
});

export const ACTUALIZAR_PLACA = "ACTUALIZAR_PLACA";
export const ACTUALIZAR_PLACA_SUCCESS = "ACTUALIZAR_PLACA_SUCCESS";
export const ACTUALIZAR_PLACA_ERROR = "ACTUALIZAR_PLACA_ERROR";

export const actualizarPlaca = (placa, onSuccess) => ({
  type: ACTUALIZAR_PLACA,
  placa,
  onSuccess,
});

export const actualizarPlacaSuccess = (respuestaServidor) => ({
  type: ACTUALIZAR_PLACA_SUCCESS,
  respuestaServidor,
});

export const actualizarPlacaError = (errorContenido) => ({
  type: ACTUALIZAR_PLACA_ERROR,
  errorContenido,
});
